<template>
  <div>
    <p>The teams average estimation of their own performance.</p>
    <div class="radar-chart-container">
      <RadarChart
        :chart-data="chartData"
        :options="chartOptions"
        :width="500"
        :height="500"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { Charts } from '@/content/reportContent.json'

import { RadarChart } from 'vue-chart-3'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler
)

export default {
  name: 'TeamSelfAwareness',
  components: {
    RadarChart
  },
  data () {
    return {
      chartData: {
        labels: ['Simple Attention', 'Attention Control', 'Short-Term Memory', 'Working Memory', 'Impulse Control', 'Creativity & Cognitive Flexibility', 'Conceptualization', 'Strategic Thinking'],
        datasets: []
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          r: {
            angleLines: {
              display: true
            },
            suggestedMin: 0,
            suggestedMax: 9
          }
        },
        plugins: {
          legend: {
            position: 'bottom'
          },
          tooltip: {
            callbacks: {
              label: (ctx) => {
                return `${ctx.dataset.label}: ${Number(ctx.parsed.r.toFixed(1))}`
              }
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      teamMembers: 'TEAMREPORTAUTO/getTeamMembers',
      teamMembersSummarized: 'TEAMREPORTAUTO/getTeamMembersSummarized',
      measureScores: 'TEAMREPORTAUTO/getMeasureScores',
      teamMeasureScores: 'TEAMREPORTAUTO/getTeamMeasureScores',
      loadedData: 'TEAMREPORTAUTO/getLoadedData'
    })
  },
  watch: {
    loadedData () {
      this.createChartDatasets()
    }
  },
  methods: {
    createChartDatasets () {
      const memberScores = this.teamMeasureScores.mean
      const mainMeasures = []
      const estimatedMainMeasures = []

      memberScores.forEach(result => {
        const mainMeasure = Charts.MainMeasures[result.measure]

        if (mainMeasure) {
          mainMeasures[mainMeasure.order] = result.stanine
          estimatedMainMeasures[mainMeasure.order] = result.comparative_performance_level
        }
      })

      this.chartData.datasets.push({
        label: 'Actual Performance',
        backgroundColor: 'transparent',
        borderColor: '#CD2E00',
        pointBackgroundColor: '#CD2E00',
        data: mainMeasures
      },
      {
        label: 'Estimated Performance',
        backgroundColor: 'transparent',
        borderColor: '#3267E3',
        pointBackgroundColor: '#3267E3',
        data: estimatedMainMeasures
      })
    }
  }
}
</script>

<style scoped>
    .radar-chart-container {
    position: relative;
    height: auto;
    width: auto;
    margin: 15px auto 0 auto;
    }
</style>
